import { Card, styled } from "@mui/material";
import colors from "../../theme/themeConstants";

export const Container = styled("div")({
  padding: "20px 1rem 5rem 1rem",
  width: "100%",
  "@media screen and (min-width: 1170px)": {
    minWidth: "690px",
    maxWidth: "50%",
    textAlign: "justify",
  },
});

export const H1 = styled("h1")({
  marginBottom: "20px",
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "30px",
  textAlign: "left",
});

export const P500 = styled("p")({
  marginBottom: "24px",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "22px",
  "& a": {
    color: colors.redPink,
    textDecoration: "unset",
    fontWeight: 700,
  }
});

export const P700 = styled("p")({
  marginBottom: "8px",
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "22px",
});

export const CardDescriptionP = styled("p")({
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
});

export const FaqAnswerP = styled("p")({
  opacity: 0.6,
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "22px",
  "& a": {
    color: colors.redPink,
    textDecoration: "unset",
    fontWeight: 700,
  }
});

export const SubHeader = styled("h4")({
  marginBottom: "8px",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "22px",
});

export const ExpandableCard = styled(Card)({
  color: "white",
  borderRadius: "16px",
  backgroundColor: colors.cardBackground,
  padding: "12px 1rem",
  "& #expandable-card-question": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "& p": { marginBottom: 0 }
});

